<template>
  <button
    class="definition-operator operator-icon"
    :class="[levelClass, {'cant-drop-here': !canDropHere, 'not-editable': thisPartIsInACountGroup}]"
    :key="operator.definitionId"
    @dblclick="editOperator($event)"
    :disabled="disableDefinitionPart"
    :draggable="false"
    @dragover="dragOverHandler"
    @dragleave="dragLeaveHandler"
    @drop="dropHandler"
  >
    <svg-icon :class="operatorConfig.icon.class"
              :icon="operatorConfig.icon.svg"
              :width="operatorConfig.icon.width" :height="operatorConfig.icon.height"></svg-icon>
  </button>
</template>

<script>
  import SvgIcon from '@/components/common/svgIcon'
  import operators from '../../models/operators'
  import DragAndDropHandlers from '../mixins/DragAndDropHandlers'
  import { UPDATE_OPERATOR } from '@/appComponents/workbench/targetDefinition/store/actions'
  import {PopoverFactory} from '@/components/common/popover'
  import { definitionPartTypes } from '../../store/mutations'

  export default {
    mixins: [
      DragAndDropHandlers
    ],
    components: {
      SvgIcon
    },
    props: {
      definitionId: {
        type: String
      },
      enableNot: {
        type: Boolean,
        default: true
      },
      enableMinus: {
        type: Boolean,
        default: true
      },
      operator: {
        type: Object,
        required: true
      },
      level: {
        type: Number,
        default: 0
      },
      disabled: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        defType: definitionPartTypes.OPERATOR
      }
    },
    computed: {
      levelClass () {
        return `level-${this.level}`
      },
      operatorConfig () {
        return operators[this.operator.value]
      },
      disableDefinitionPart () {
        // TODO: remove hook to store
        let disabled = this.$store.getters['workbench/disableDefinitionPart']
        return disabled ? disabled(this.definitionId) : false
      },
      thisPartIsInACountGroup () {
        let inCountGroup = this.$store.getters['workbench/isInACountGroup']
        return inCountGroup ? inCountGroup(this.definitionId) : false
      }
    },
    methods: {
      updateOperator (updatedOperator) {
        this.$store.dispatch('workbench/' + UPDATE_OPERATOR, {operator: this.operator, update: updatedOperator})
      },
      editOperator (e) {
        if (this.thisPartIsInACountGroup || this.disabled) return
        this.popover = PopoverFactory.createOperator({
          direction: 'top',
          operatorSelector: true,
          parent: e.currentTarget,
          miliseconds: 200,
          enableNot: this.enableNot,
          enableMinus: this.enableMinus
        })
        this.popover.$on('select', operator => {
          this.updateOperator(operator)
        })
      }
    }
  }
</script>

<style lang="scss">
  .definition-operator {
    $bg-color: color(blue-black, dark);

    position: relative;
    z-index: $z-1;
    flex-shrink: 0;
    flex-grow: 0;
    height: rem(40);
    width: rem(40);
    padding: 0;
    text-align: center;
    border-radius: 50%;
    border: rem(5) solid $bg-color;

    &.not-editable {
      cursor: not-allowed;
    }

    &.level-1 {
      background-color: color(target, level-1);

      &:hover {
        background-color: color(target, level-1-light);
      }
    }

    &.level-2 {
      background-color: color(target, level-2);

      &:hover {
        background-color: color(target, level-2-light);
      }
    }

    svg {
      margin: auto;
      fill: $bg-color;
    }

    &:focus {
      outline: none;
    }

    &:disabled:hover {
      border-color: $bg-color;
    }
  }
</style>



// WEBPACK FOOTER //
// DefinitionOperator.vue?67b8a55e